module.exports = __webpack_public_path__ + "assets/img/error.f5838a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgRes/error.png
// module id = 321
// module chunks = 1